import React from 'react';
import Step1Slices from './Step1Slices';

const QuestionaryStep1 = (props) => <Step1Slices {...props} />;

export default QuestionaryStep1;
